import { BuzzBootstrapInput } from '../types'

export function createBuzzLocalFixture(
  pathname: string,
  search: string,
  enabled: boolean,
): BuzzBootstrapInput | null {
  if (!enabled || new URLSearchParams(search).get('buzzFixture') !== '1') return null
  const organizationId = pathname.match(
    /^\/organization\/([A-Za-z0-9._-]+)\/(?:member|messaging)\/?$/,
  )?.[1]
  if (!organizationId) return null
  const userId = `local-user-${organizationId}`
  return {
    organization: { id: organizationId, name: 'Equa Chat Local Verification' },
    currentUser: { id: userId, fullName: 'Local Equa User' },
    members: [{
      id: `local-member-${organizationId}`,
      user: userId,
      fullName: 'Local Equa User',
      role: 'owner',
    }],
    agents: [{ id: `local-agent-${organizationId}`, name: 'Local Equanaut', status: 'online' }],
  }
}

export function createBuzzLocalStateActions(
  fixture: BuzzBootstrapInput,
): Array<{ type: string; data: any }> {
  const member = fixture.members[0]
  return [{
    type: 'GET_CURRENT_USER_SUCCESS',
    data: {
      user: {
        id: fixture.currentUser.id,
        username: fixture.currentUser.fullName,
        email: 'local-fixture@invalid.example',
        emailVerified: true,
        acceptedTerms: true,
      },
      profile: { fullName: fixture.currentUser.fullName },
      status: true,
    },
  }, {
    type: 'CURRENT_ORGANIZATION_SUCCESS',
    data: {
      id: fixture.organization.id,
      name: fixture.organization.name,
      creator: fixture.currentUser.id,
      members: fixture.members.map((candidate) => ({
        ...candidate,
        organization: fixture.organization.id,
      })),
      agent: fixture.agents,
      features: [],
      taxIds: [],
      email: member?.user ? 'local-fixture@invalid.example' : '',
    },
  }]
}
